import React from 'react';
import styled from 'styled-components';
import { Container, Media } from '../../components';
import { CoreValuesMissionDesktop } from './desktop';
import { CoreValuesMissionMobile } from './mobile';
import { CoreValuesMissionTablet } from './tablet';

const DesktopWrapper = styled.div`
  background-color: #faf2f4;
`;

export const CoreValuesMission = React.forwardRef<any>((props, ref) => {
  return (
    <section ref={ref}>
      <DesktopWrapper>
        <Media greaterThanOrEqual="xmd">
          <CoreValuesMissionDesktop />
        </Media>
      </DesktopWrapper>
      <Container>
        <Media at="md">
          <CoreValuesMissionTablet />
        </Media>
      </Container>
      <Container>
        <Media at="sm">
          <CoreValuesMissionMobile />
        </Media>
      </Container>
    </section>
  );
});
